<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="ENCUESTAS" key="1">
          <g-master name="poll"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    ref="master"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Nombre corto')">
                    <a-input
                      v-decorator="['short_name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Descripción')">
                    <a-input
                      v-decorator="['description', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :label="$t('Tipo de encuesta')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_h_poll_type', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                              :params="tipo_encuesta"
                  >
                  </g-dropdown>
                </a-col>

                <a-col v-bind="colOptions">
                  <g-dropdown endpoint="role"
                              :label="$t('Nombre del rol')"
                              :formItemConfig="fiOptions"
                              :decorator="['role_name', { rules: [{ required: false }] }]"
                  >
                  </g-dropdown>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha de apertura')">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['open_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                    ></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha de cierre')">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['closing_date', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                    ></a-date-picker>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Estado')" :has-feedback="false">
                    <a-checkbox
                      v-decorator="['active', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                    </a-checkbox>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs defaultActiveKey="2">
            <a-tab-pane tab="REGLAS" key="2">
              <mantenimiento-poll-rules v-if="idForm" :id="idForm"></mantenimiento-poll-rules>
              <span v-else>Seleccione una encuesta para ver más.</span>
            </a-tab-pane>
            <a-tab-pane tab="CATEGORIA" key="1">
              <mantenimiento-poll-category v-if="idForm" :id="idForm"></mantenimiento-poll-category>
              <span v-else>Seleccione una encuesta para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        tipo_encuesta: {h_lookup_type: 'TIPO_ENCUESTA'},
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'polls',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Nombre corto', dataIndex: 'short_name', sorter: true},
              {title: 'Descripción', dataIndex: 'description', sorter: true},
              {title: 'Tipo de encuesta', dataIndex: 'poll_type', sorter: true},
              {title: 'Nombre del rol', dataIndex: 'role_name', sorter: true},
              {title: 'Fecha de apertura', dataIndex: 'open_date_desc', sorter: true},
              {title: 'Fecha de cierre', dataIndex: 'closing_date_desc', sorter: true},
              {title: 'Estado', dataIndex: 'active_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'active', type: 'boolean'},
            {name: 'closing_date', type: 'date'},
            {name: 'description'},
            {name: 'id_h_poll_type'},
            {name: 'open_date', type: 'date'},
            {name: 'role_name'},
            {name: 'short_name'}
          ]
        }
      }
    },
    computed: {
      idForm () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Poll/Poll.vue